import React, { useCallback } from 'react'
import { useTranslation } from '@hooks/useTranslation'
import { InvoiceHeader } from '@EUForms/invoice'
import InvoiceDetail from './InvoiceDetail'
import { useDispatch, useSelector } from 'react-redux'
import MassUpdateAES from './massUpdateAES'
import { itemActions } from '../../reducer/ItemSlice'
import { useEvent } from '@hooks/useEvent'

const InvoiceContainer = () => {
  const translate = useTranslation()
  const dispatch = useDispatch()
  const dataSource = useSelector((state) => state.invoiceReducer.invoice.invoiceUpperHeader)
  const { saveForm } = useEvent('invoiceTab')
  const {updateInvoiceUpperHeader} = itemActions
  const onSelect = useCallback(
    (e, { value, name }) => {
      dispatch(updateInvoiceUpperHeader({ [name]: value?.trim() }))
      saveForm({ invoiceUpperHeader: { [name]: value } })
    },
    [updateInvoiceUpperHeader, saveForm]
  )

  return (
    <div className='headerDetails formContentareaC88'>
      <InvoiceHeader translate={translate} dataSource={dataSource} onSelect={onSelect} />
      <MassUpdateAES />
      <InvoiceDetail translate={translate} />
    </div>
  )
}

export default React.memo(InvoiceContainer)
